
import { useState } from "react";
import { useAuth } from "@/components/AuthProvider";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { useTranslations } from "@/hooks/useTranslations";

export const GeneralSettings = () => {
  const { t } = useTranslations("settings");
  const [settings, setSettings] = useState({
    language: "pt",
    timezone: "Europe/Lisbon",
    currency: "EUR",
  });

  const handleSave = () => {
    // TODO: Implementar integração com backend
    toast.success("Configurações gerais atualizadas");
  };

  return (
    <Card className="rounded-xl overflow-hidden">
      <CardHeader className="bg-gray-50 dark:bg-gray-900 rounded-t-xl">
        <CardTitle>{t("general.title")}</CardTitle>
        <CardDescription>
          {t("general.description")}
        </CardDescription>
      </CardHeader>
      <CardContent className="bg-gray-50 dark:bg-gray-900 rounded-b-xl">
        <div className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="language">{t("general.language")}</Label>
            <Select
              value={settings.language}
              onValueChange={(value) => setSettings(prev => ({ ...prev, language: value }))}
            >
              <SelectTrigger className="rounded-xl">
                <SelectValue placeholder="Selecione o idioma" />
              </SelectTrigger>
              <SelectContent className="dropdown-opaque rounded-xl">
                <SelectItem value="pt">Português</SelectItem>
                <SelectItem value="en">English</SelectItem>
                <SelectItem value="es">Español</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="timezone">{t("general.timezone")}</Label>
            <Select
              value={settings.timezone}
              onValueChange={(value) => setSettings(prev => ({ ...prev, timezone: value }))}
            >
              <SelectTrigger className="rounded-xl">
                <SelectValue placeholder="Selecione o fuso horário" />
              </SelectTrigger>
              <SelectContent className="dropdown-opaque rounded-xl">
                <SelectItem value="Europe/Lisbon">Lisboa (GMT+00:00)</SelectItem>
                <SelectItem value="Europe/London">Londres (GMT+00:00)</SelectItem>
                <SelectItem value="Europe/Paris">Paris (GMT+01:00)</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="currency">{t("general.currency")}</Label>
            <Select
              value={settings.currency}
              onValueChange={(value) => setSettings(prev => ({ ...prev, currency: value }))}
            >
              <SelectTrigger className="rounded-xl">
                <SelectValue placeholder="Selecione a moeda" />
              </SelectTrigger>
              <SelectContent className="dropdown-opaque rounded-xl">
                <SelectItem value="EUR">Euro (€)</SelectItem>
                <SelectItem value="USD">Dólar ($)</SelectItem>
                <SelectItem value="GBP">Libra (£)</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <Button onClick={handleSave} className="rounded-xl">{t("general.saveButton")}</Button>
        </div>
      </CardContent>
    </Card>
  );
};
